let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4E7mO")).then(() => parcelRequire('cfbO3'));